import * as React from "react";
function SvgUserTag(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M23 29h-5l-1-5 7-9 6 5-7 9z"
      />
      <circle
        cx={20.54}
        cy={26.08}
        r={1}
        transform="rotate(-51.27 20.542 26.086)"
      />
      <circle
        cx={12}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M7.11 29H1a11 11 0 0118.54-8"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserTag);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
